import { useEffect } from "react";

export const useScript = (body, runScript) => {
    useEffect(() => {
        if (runScript && body) {
            const script = document.createElement('script');
            const id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);

            script.innerHTML = `try { ${body.replace(/\\n/g, '') } } catch (err) { };`
            script.async = true;
            script.id = id;

            document.body.appendChild(script);

            return () => {
                document.getElementById(id).remove();
            }
        }
    }, [body]);
}